/**
 * Zentrales Design-Token-System für responsive UI.
 * Gibt clamp()-Strings zurück, die auf Mobile (740x360) und Desktop (1920x1080) skalieren.
 */

// ── Font Tokens ──────────────────────────────────────────
export const fontXs  = () => 'clamp(9px, 2.2vw, 11px)';
export const fontSm  = () => 'clamp(10px, 2.4vw, 12px)';
export const fontBase = () => 'clamp(11px, 2.6vw, 13px)';
export const fontMd  = () => 'clamp(13px, 2.8vw, 14px)';
export const fontLg  = () => 'clamp(14px, 3.2vw, 18px)';
export const fontXl  = () => 'clamp(18px, 4vw, 22px)';

// ── Spacing Tokens ───────────────────────────────────────
export const padXs  = () => 'clamp(4px, 1vw, 6px)';
export const padSm  = () => 'clamp(6px, 1.5vw, 10px)';
export const padMd  = () => 'clamp(10px, 2vw, 16px)';
export const padLg  = () => 'clamp(14px, 3vw, 24px)';
export const padXl  = () => 'clamp(18px, 3.5vw, 32px)';

// ── Gap Tokens ───────────────────────────────────────────
export const gapSm  = () => 'clamp(4px, 1vw, 8px)';
export const gapMd  = () => 'clamp(8px, 1.5vw, 12px)';
export const gapLg  = () => 'clamp(12px, 2.5vw, 24px)';

// ── Panel Tokens ─────────────────────────────────────────
export const panelSm = () => 'clamp(200px, 35vw, 280px)';
export const panelMd = () => 'clamp(240px, 40vw, 320px)';

// ── Radius ───────────────────────────────────────────────
export const radius  = () => 'clamp(6px, 1.2vw, 10px)';

// ── Button Padding (Touch-safe) ──────────────────────────
export const btnPad  = () => 'clamp(8px, 2vw, 12px) clamp(12px, 3vw, 16px)';

// ── Mobile Detection ─────────────────────────────────────
export function isMobile(): boolean {
  return window.innerWidth < 960 || window.innerHeight < 500;
}

// ── Touch Button Helper ──────────────────────────────────
export function touchBtn(style: Partial<CSSStyleDeclaration>): Partial<CSSStyleDeclaration> {
  return { ...style, minHeight: '44px' };
}

// ── CSS Custom Properties ────────────────────────────────
export function injectResponsiveVars(): void {
  const root = document.documentElement.style;
  root.setProperty('--ui-font-xs', fontXs());
  root.setProperty('--ui-font-sm', fontSm());
  root.setProperty('--ui-font-base', fontBase());
  root.setProperty('--ui-font-md', fontMd());
  root.setProperty('--ui-font-lg', fontLg());
  root.setProperty('--ui-font-xl', fontXl());
  root.setProperty('--ui-pad-xs', padXs());
  root.setProperty('--ui-pad-sm', padSm());
  root.setProperty('--ui-pad-md', padMd());
  root.setProperty('--ui-pad-lg', padLg());
  root.setProperty('--ui-pad-xl', padXl());
  root.setProperty('--ui-gap-sm', gapSm());
  root.setProperty('--ui-gap-md', gapMd());
  root.setProperty('--ui-gap-lg', gapLg());
  root.setProperty('--ui-radius', radius());
}
